/**
 * 랜딩 페이지 템플릿 - 공통 레이아웃 컴포넌트
 * 다양한 앱에서 재사용 가능한 범용 랜딩 페이지 템플릿
 */ function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  min-height: 100vh;\n  background: linear-gradient(135deg, \n    var(--background-gradient-from, #f0f9ff) 0%, \n    var(--background-gradient-to, #e0e7ff) 100%);\n  transition: background 0.3s ease;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  max-width: 80rem;\n  margin: 0 auto;\n  padding: 1rem;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n  \n  @media (min-width: 640px) {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  \n  @media (min-width: 1024px) {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  background-color: #ffffff;\n  border-top: 1px solid #e5e5e5;\n  padding: 2rem 0;\n  \n  p {\n    text-align: center;\n    color: #4b5563;\n    max-width: 80rem;\n    margin: 0 auto;\n    padding: 0 1rem;\n    \n    @media (min-width: 640px) {\n      padding: 0 1.5rem;\n    }\n    \n    @media (min-width: 1024px) {\n      padding: 0 2rem;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 4rem;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
import { HeroSection } from './HeroSection';
import { FeatureGrid } from './FeatureGrid';
import { LandingPageHeader } from './LandingPageHeader';
import * as m from "@paraglide/messages";
// 스타일 컴포넌트
var PageContainer = styled.div(_templateObject());
var MainContainer = styled.main(_templateObject1());
var StyledFooter = styled.footer(_templateObject2());
var SectionMarginBottom = styled.div(_templateObject3());
/**
 * 랜딩 페이지 템플릿 컴포넌트
 * 
 * @example
 * ```tsx
 * <LandingPageTemplate
 *   content={{
 *     hero: {
 *       title: "Welcome to ",
 *       gradientText: "Your App",
 *       titleSuffix: " Platform",
 *       description: "Your app description here..."
 *     },
 *     features: {
 *       title: "Key Features",
 *       items: [
 *         { icon: "🚀", title: "Feature 1", description: "..." }
 *       ]
 *     }
 *   }}
 *   header={{
 *     logoText: "Your App",
 *     showPricing: true,
 *     showLanguageSelector: true
 *   }}
 *   hero={{
 *     actions: <YourActionButton />
 *   }}
 * />
 * ```
 */ export var LandingPageTemplate = function(param) {
    var content = param.content, header = param.header, hero = param.hero, features = param.features, footer = param.footer, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, children = param.children;
    var _content_footer;
    return /*#__PURE__*/ React.createElement(PageContainer, {
        className: className
    }, header && /*#__PURE__*/ React.createElement(LandingPageHeader, {
        logoText: header.logoText,
        onLogoClick: header.onLogoClick,
        showPricing: header.showPricing,
        showLanguageSelector: header.showLanguageSelector,
        rightActions: header.rightActions,
        onPricingClick: header.onPricingClick,
        logoTextStyle: header.logoTextStyle
    }), /*#__PURE__*/ React.createElement(MainContainer, null, /*#__PURE__*/ React.createElement(HeroSection, {
        title: content.hero.title,
        titleSuffix: content.hero.titleSuffix,
        description: content.hero.description,
        gradientText: content.hero.gradientText,
        actions: hero === null || hero === void 0 ? void 0 : hero.actions,
        customContent: hero === null || hero === void 0 ? void 0 : hero.customContent
    }), /*#__PURE__*/ React.createElement(SectionMarginBottom, null, (features === null || features === void 0 ? void 0 : features.customGrid) ? features.customGrid : /*#__PURE__*/ React.createElement(FeatureGrid, {
        title: content.features.title,
        features: content.features.items
    })), children), /*#__PURE__*/ React.createElement(StyledFooter, null, (footer === null || footer === void 0 ? void 0 : footer.customContent) ? footer.customContent : /*#__PURE__*/ React.createElement("p", null, "\xa9 ", new Date().getFullYear(), " ", ((_content_footer = content.footer) === null || _content_footer === void 0 ? void 0 : _content_footer.copyright) || m.landing_footer_copyright())));
};
export default LandingPageTemplate;
